export default "__VITE_ASSET__5c3e4ce2__"